import {type LeaderboardRowData} from '../../../../shared/leaderboard_data/LeaderboardInterfaces.ts'
import {LeaderboardConstants} from '../../../../shared/leaderboard_data/LeaderboardConstants.ts'
import {type UILeaderboardBaseTableRowView} from './UILeaderboardBaseTableRowView.ts'
import {UILeaderboardTableRowViewRanked} from './UILeaderboardTableRowViewRanked.ts'
import {type UILeaderboardStickyRowController} from './UILeaderboardStickyRowController.ts'
import {type TranslationObject} from '@colonist/i18n'
import {setElementInnerHTML} from '../ui_utils/DomUtils.ts'

export class UILeaderboardTableController {
    readonly tableContainer: HTMLDivElement
    protected readonly tablebody: HTMLDivElement
    private readonly noFriendsDisplay: HTMLDivElement

    private readonly fetchDataCallback: () => void

    protected hasReachedDataEnd = false
    protected tableRowViews: UILeaderboardBaseTableRowView[]
    private readonly stickyRowController: UILeaderboardStickyRowController

    constructor(fetchDataCallback: () => void, stickyRowController: UILeaderboardStickyRowController) {
        this.tableRowViews = []

        this.stickyRowController = stickyRowController
        this.fetchDataCallback = fetchDataCallback
        this.tableContainer = document.getElementById('leaderboard_ranking_table_container') as HTMLTableElement
        this.tablebody = document.getElementById('leaderboard_ranking_table') as HTMLTableElement
        this.noFriendsDisplay = document.getElementById('leaderboard_no_friends_display') as HTMLDivElement

        this.tableContainer.addEventListener('scroll', () => {
            this.scrollAction()
            this.updateStickyRowStyle()
        })
        window.addEventListener('resize', () => {
            this.updateStickyRowStyle()
        })
    }

    private scrollAction() {
        if(this.hasReachedDataEnd) return
        const scrollPositionPx = this.tableContainer.scrollTop
        const tableContainerHeightPx = this.tableContainer.clientHeight
        const marginFromBottomToLoadMoreDataInPx = tableContainerHeightPx * 0.1
        const maxScrollPositionPx = this.tablebody.clientHeight - tableContainerHeightPx
        const isScrolledCloseToEnd = scrollPositionPx > maxScrollPositionPx - marginFromBottomToLoadMoreDataInPx
        if(!isScrolledCloseToEnd) return

        this.fetchDataCallback()
    }

    updateStickyRowStyle() {
        const scrollPositionPx = this.tableContainer.scrollTop
        const gridHeightPx = this.tableContainer.clientHeight
        const myRowIndex = this.getMyRowIndex()
        this.stickyRowController.updateStickyRowStyle(gridHeightPx, scrollPositionPx, myRowIndex)
    }

    getRowCount(): number {
        return this.tableRowViews.length
    }

    updateRankingData(rowDatas: LeaderboardRowData[], onLeaderboardUrlChange: (leaderboardUrl: string) => void) {
        this.hasReachedDataEnd = rowDatas.length !== LeaderboardConstants.maximumLeaderboardAPIRankingRangeLimit
        for(const rowData of rowDatas) {
            const tableRowView = new UILeaderboardTableRowViewRanked(this.tablebody, rowData, this.getRowCount(), onLeaderboardUrlChange)
            this.tableRowViews.push(tableRowView)
        }
    }

    getMyRowIndex(): number | undefined {
        for(const [index, tableRowView] of this.tableRowViews.entries()) {
            if(tableRowView.rowData.myData) return index
        }
        return undefined
    }

    scrollToTop() {
        this.tableContainer.scrollTop = 0
    }

    clearData() {
        this.tablebody.replaceChildren()
        this.noFriendsDisplay.replaceChildren()
        this.tableRowViews = []
    }

    displayNoContentMessage() {
        const message: TranslationObject = {key: 'strings:leaderboardPage.noRankedFriends'}
        setElementInnerHTML(this.noFriendsDisplay, message)
    }
}
